<template>
    <ldc-dialog
        :title="title"
        :colorTitle="colorTitle"
        :clickoutside="true"
        width="50%"
        :fullscreen="$detect == 'mobile'"
        :class="{
            'product-dialog' : true,
            'product-dialog-web' : $detect == 'web',
            'modal-register-vip': $detect == 'web',
            'modal-mobile-vip position-relative': $detect == 'mobile',
            'modal-HappyLink' : action == 'HappyLink',
            'modal-dght' : action == 'dght',
            'modal-normal' : action == 'auto',
        }"
        :visible.sync="dialog">
        <div class="content-modal py-3 px-10px">
            <div class="d-flex">
                <div :class="{
                            'w-35' : true,
                            'fw-600' :  $detect == 'mobile'
                        }">
                    <div class="name">
                        Hinh thức khuyễn mãi:
                    </div>
                </div>
                <div class="w-65">
                    <div class="value d-flex">
                        <select name="" v-model="product.type_reduce" :class="{
                                                                                'mr-3' : $detect == 'web',
                                                                                'mr-1' : $detect == 'mobile',
                                                                                }">
                            <option value="0">Phần trăm</option>
                            <option value="1">Giá trị</option>
                        </select>
                        <input type="text" :class="{
                                                'input-time-vip mr-1 text-right input-link' : true,
                                                'input-link-mobile' : $detect == 'mobile'
                                                }"
                            v-model="product.prp_value" ref="input-action-dialog" value="0" 
                            @focus="(e) => e.target.select()"/>
                        <span v-if="product.type_reduce == 0">%</span>
                        <span v-else style="color: #f44f00;">₫</span>
                    </div>
                </div>
            </div>
            <div class="d-flex mt-3">
                <div :class="{
                                'w-35' : true,
                                'd-flex justify-content-center align-items-center fw-600' : $detect == 'mobile'
                            }">
                    <div class="name">Thời gian bắt đầu:</div>
                </div>
                <div class="w-65">
                    <div class="value">
                        <div class="content-change-time mt-2">
                            <div :class="{'d-flex' : $detect == 'web', 'justify-content-between' : $detect == 'mobile'}">
                                <div :class="{
                                        'fw-600' : true,
                                        'mr-3'   : $detect == 'web',
                                        'mb-1' : $detect == 'mobile'
                                    }">
                                  <input type="date" :class="{
                                                                'date-change' : true,
                                                                }" v-model="product.date_start"
                                        />
                                </div>
                                <div>
                                    <ldc-time placeholder="HH:mm"
                                        :showSeconds="false"
                                        :jumpMinutes="5"
                                        titleMobile="Thời gian"
                                        v-model="product.time_start"
                                        :class="{
                                            'time-change' : true,
                                            'input-time-mobile' : $detect == 'mobile',
                                            }"
                                        />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex mt-3">
                <div :class="{
                            'w-35' : true,
                            'd-flex justify-content-center align-items-center fw-600' : $detect == 'mobile'
                        }">
                    <div class="name">Thời gian kết thúc:</div>
                </div>
                <div class="w-65">
                    <div class="value">
                        <div class="content-change-time mt-2">
                            <div :class="{'d-flex' : $detect == 'web', 'justify-content-between' : $detect == 'mobile'}">
                                <div :class="{
                                        'fw-600' : true,
                                        'mr-3'   : $detect == 'web',
                                        'mb-1' : $detect == 'mobile'
                                    }">
                                  <input type="date" :class="{
                                                                'date-change' : true,
                                                                }" v-model="product.date_end"
                                        />
                                </div>
                                <div>
                                    <ldc-time placeholder="HH:mm"
                                        :showSeconds="false"
                                        :jumpMinutes="1"
                                        titleMobile="Thời gian"
                                        v-model="product.time_end"
                                        :class="{
                                            'time-change' : true,
                                            'input-time-mobile' : $detect == 'mobile',
                                        }"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex mt-3">
                <div :class="{
                            'w-35' : true,
                            'fw-600' :  $detect == 'mobile'
                        }">
                    <div class="name">
                        Số lượng tham gia:
                    </div>
                </div>
                <div class="w-65">
                    <div class="value d-flex">
                        <select name="" v-model="product.estore_quantity" :class="{
                                                                                    'mr-3' : $detect == 'web',
                                                                                    'mr-1' : $detect == 'mobile',
                                                                                }">
                            <option value="1">Không giới hạn</option>
                            <option value="0">Chọn số lượng</option>
                        </select>
                        <input type="text" :class="{
                                'input-time-vip mr-1 text-right input-estore_quantity' : true,
                                'back-brow' : product.estore_quantity == 1,
                                'input-link-mobile' : $detect == 'mobile'
                            }" :disabled="product.estore_quantity == 1" 
                            v-model="product.quantity" ref="input-action-dialog" placeholder="Nhập số lượng tham gia.." 
                            @focus="(e) => e.target.select()"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-modal text-center">
            <button :class="{
                    'btn btn-confirm my-10px mr-10px': true,
                    'btn-sm': $detect == 'web'
                }"
                @click="submit()"
                >Xác nhận</button>
        </div>
    </ldc-dialog>
</template>
<script>
export default {
    props: ['visible', 'data', 'action', 'multiple', 'dataMultiple', 'dayNow'],
    data() {
        return {
            dialog: false,
            title: '',
            actionMuti: false,
            loading: false,
            source_pay: this.$detect == 'web' ? 0: 1,
            checkDataLink : false,
            colorTitle : '',
            product : [],
        }
    },
    watch: {
        'product.estore_quantity'(){
            this.product.quantity = 0;
        },
        'product.prp_value'(val){
            this.ckeckSale(val);
        },
        'product.type_reduce'(){
            this.ckeckSale(this.product.prp_value);
        },
        visible(val){
            this.dialog = val;
        },
        dialog(val){
            getMoney();
            this.$emit('update:visible', val);
            if(val){
                this.total = 0;
                this.amount = '';
                setTimeout(() => {
                    this.$refs['input-action-dialog'].focus();
                }, 100)
            }
        },
        action(val){
            if(val == 'HappyLink'){
                this.title = 'Cấu hình khuyễn mãi';
                this.oneManipulation = this.config.con_raovat_vip_price;
                this.colorTitle = '#dc3545';
            }else if(val == 'dght'){
                this.title = 'Tham gia đấu giá hiển thị sản phẩm';
                this.oneManipulation = this.config.con_raovat_super_vip_price;
                this.colorTitle = '#20c997';
            }else if(val == 'auto'){
                this.title = 'Up tự động';
                this.oneManipulation = this.config.con_raovat_up_price;
                this.colorTitle = '#0c81f6';
            }
        },
        data(val){
            this.product = val;
        },
        amount(newVal, oldVal) {
            if(newVal * 1 == newVal && newVal % 1 == 0){
                if(newVal <= 1000){
                    if(this.actionMuti){

                    }else{
                        this.singleAction();
                    }
                }else{
                    this.amount = 1000;
                }
            }else{
                this.amount = oldVal;
            }
        }
    },
    created (){
        this.product = this.data;
    },
    computed: {
        config(){
            return this.$store.state.config;
        },
        money(){
            return this.$store.state.money;
        },
    },
    methods: {
        ckeckSale(val){
            if(this.product.type_reduce == 0){
                //phần trăm
                if(val < 100 && val > 0){
                    this.product.price_promotion = this.product.price_format - ((this.product.price_format * val)/100);
                }else{
                    this.$message({
                        message: "Bạn nhập sai giá trị (0->99)! Ok",
                        type: 'warning',
                        center: true,
                    });
                    this.product.prp_value = 0;
                    this.product.price_promotion = this.product.price_format;
                }
            }else{
                //giá trị
                if(val > this.product.price_format){
                     this.$message({
                        message: "Giá tiền khuyễn mãi không được lớn hơn giá gốc!",
                        type: 'warning',
                        center: true,
                    });
                    this.product.prp_value = 0;
                    this.product.price_promotion = this.product.price_format;
                }else{
                    this.product.price_promotion = this.product.price_format - val;
                }
            }
        },
        maxAmount(){
            this.max_amount = this.$formatNumber(this.max_amount)
        },
        singleAction(){
            if(!this.multiple){
                this.total = this.amount * this.oneManipulation.money;
            }else{
                this.total = this.amount * this.oneManipulation.money * this.dataMultiple.length;
            }
        },
        submit(){
            if(parseInt(this.dayNow.replace(/-/g,""),10) > parseInt(this.product.date_start.replace(/-/g,""),10)){
                this.$message({
                    message: 'Hãy thiết lập lại thời gian',
                    type: 'warning',
                    center: true,
                });
            }else if(parseInt(this.product.date_start.replace(/-/g,""),10) > parseInt(this.product.date_end.replace(/-/g,""),10)){
                this.$message({
                    message: 'Ngày bắt đầu không được lón hơn ngày kết thúc',
                    type: 'warning',
                    center: true,
                });
            }else if(this.product.quantity < 0){
                this.$message({
                    message: 'Số lượng không được nhỏ hơn 0',
                    type: 'warning',
                    center: true,
                });
            }else{
                 this.$emit('update:visible', false);
            }
        },
    }
}
</script>
<style lang="scss">
.w-35{
    width : 35%;
}
.w-65{
    width: 65%;
}
.modal-mobile-vip{
    &.modal-HappyLink{
        .title-dialog{
            background : #dc3545;
        }
    }
}

.modal-mobile-vip{
    .content-modal{
        margin-top : 0;
    }
    &.modal-HappyLink {
        .footer-modal{
            .btn-confirm, .btn-danger{
                width: 40%;
            }
        }
    }
}
.input-time-mobile{
    .input-time-mobile{
        width : 174px!important;
    }
}
    .modal-register-vip, .modal-mobile-vip{
        &.modal-HappyLink{
            .title-dialog {
                border-bottom: 1px solid #dc3545;
            }
            .footer-modal{
                border-top: 1px solid #dc3545;
                .btn-confirm{
                    color: white;
                    background : #dc3545;
                }
            }
        }
        &.modal-dght {
            .title-dialog {
                border-bottom: 1px solid #20c997;
            }
            .footer-modal{
                border-top: 1px solid #20c997;
                .btn-confirm{
                    color: white;
                    background : #20c997;
                }
            }
        }
    }
    .product-dialog{
        &.product-dialog-web{
            .content-modal .value .input-link{
                width: 143px;
            }
        }
        .content-change-time{
            .date-change{
                height: 35px;
                border-radius: 4px;
                border: 1px solid rgba(0, 0, 0, 0.2);
                color: #606266;
                outline: none;
                cursor: pointer;
            }
        }
        .content-modal{
            .value{
                select{
                    height: 35px;
                    width: 155px;
                    border-radius: 4px;
                    border: 1px solid rgba(0, 0, 0, 0.2);
                    color: #606266;
                    outline: none;
                    cursor: pointer;
                }
                span{
                    height: 35px;
                    border-radius: 4px;
                    border: 1px solid rgba(0, 0, 0, 0.2);
                    color: #606266;
                    outline: none;
                    padding: 0 10px;
                    cursor: pointer;
                    line-height: 35px;
                }
                .select-dght{
                    height: 35px;
                    border-radius: 4px;
                    border: 1px solid rgba(0, 0, 0, 0.2);
                    color: #606266;
                    outline: none;
                    cursor: pointer;
                    width: 155px;
                }
                .input-link{
                    
                    &.input-link-mobile{
                        width : 82px!important;
                        border : 1px solid #bdc3c7;
                        padding-right : 5px;
                        border-radius : 4px!important;
                    }
                }
                .input-estore_quantity{
                    width : 180px;
                    &.back-brow{
                        background: #f1f0f0;
                    }
                    &.input-link-mobile{
                        width : 85px!important;
                        border : 1px solid #bdc3c7;
                        padding-right : 5px;
                        border-radius : 4px!important;
                    }
                }
                .input-price-vip{
                    width: 155px;
                    color : #dc3545;
                }
            } 
        }
    }
@media (max-width: 370px) {
    .pro-duct{
        .product-dialog{
            .main-dialog{
                .name{
                    font-size : 14px;
                }
                .value{
                    select{
                        width : 110px;
                    }
                    .input-link-mobile{
                        width: 57px !important;
                    }
                    span{
                        padding : 0 5px;
                    }
                    .input-estore_quantity{
                        &.input-link-mobile{
                            width: 74px !important;
                        }
                    }
                }
            }
        }
    }
}
</style>
